// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 执行后台主控操作 按当前身份及资源授权处理，写操作按业务请求标识去重 POST /bossApi/conference/core/stageControl/v1/command */
export async function executeBossStageControlCommand(
  body: CoreAPI.ActivityProcessStageCommandRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseActivityProcessCommandResult>(
    '/bossApi/conference/core/stageControl/v1/command',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 查看后台舞台场控 按当前身份及资源授权处理，写操作按业务请求标识去重 POST /bossApi/conference/core/stageControl/v1/snapshot */
export async function getBossStageControlSnapshot(
  body: CoreAPI.ActivityProcessProcessRefRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseActivityProcessStageSnapshot>(
    '/bossApi/conference/core/stageControl/v1/snapshot',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}
